// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactLoadingSkeleton from "react-loading-skeleton";
import ReactLoadingSkeleton$1 from "react-loading-skeleton";
import * as SpotEstimateFormLoaderModuleScss from "../styles/SpotEstimateFormLoader.module.scss";

var styles = SpotEstimateFormLoaderModuleScss;

import 'react-loading-skeleton/dist/skeleton.css'
;

function SpotEstimateFormLoaderCmp(Props) {
  return React.createElement(ReactLoadingSkeleton.SkeletonTheme, {
              baseColor: "#e6e6e6",
              highlightColor: "#FEFEFE",
              duration: 2.0,
              children: React.createElement("div", {
                    className: styles["vehicle-results-wrapper"]
                  }, React.createElement("div", {
                        className: styles["vehicles-wrapper"]
                      }, React.createElement(ReactLoadingSkeleton$1, {
                            height: "4.4rem",
                            borderRadius: "0.4rem",
                            containerClassName: styles["skeleton-2"]
                          })), React.createElement("div", {
                        className: styles["vehicles-wrapper"]
                      }, React.createElement(ReactLoadingSkeleton$1, {
                            height: "4.4rem",
                            borderRadius: "0.4rem",
                            containerClassName: styles["skeleton-2"]
                          })), React.createElement("div", {
                        className: styles["vehicles-wrapper"]
                      }, React.createElement(ReactLoadingSkeleton$1, {
                            height: "4.4rem",
                            borderRadius: "0.4rem",
                            containerClassName: styles["skeleton-2"]
                          })))
            });
}

var make = SpotEstimateFormLoaderCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
